import type { ChecklistItemStatus } from '../../../../components/checklist';
import { usePurchases } from '../../../purchases/hooks/use-purchases';
import { useTrackedCustomer } from '../customer/use-tracked-customer';

// The purchasing API only holds B2B purchases, so any `order` placed by the freshly-created
// test customer completes the step — no platform order tag needed, and no date bound (the test
// customer has no prior orders, so existence alone is the signal).
export function useChecklistStatus(): ChecklistItemStatus | undefined {
  const { customer, isLoading: isCustomerLoading } = useTrackedCustomer();

  // We only need to know an order exists, so cap the fetch at one.
  const { data: orders, isLoading: isOrdersLoading } = usePurchases(
    customer ? { type: 'order', customerIds: [customer.id], limit: 1 } : undefined,
    { enabled: !!customer },
  );

  if (isCustomerLoading) {
    return undefined;
  }
  // No test customer yet (earlier step incomplete) → nothing could have been ordered.
  if (!customer) {
    return 'pending';
  }
  if (isOrdersLoading) {
    return undefined;
  }
  return (orders?.length ?? 0) > 0 ? 'complete' : 'pending';
}
